<div class="search-head">
  <div class="search-head__input">
   
    <input type="text" class="form-control" 
      placeholder="{{getPlaceholder()}}"
      [(ngModel)]="attribute.value"
      (keyup.enter)="doSearch()">
    
  </div>
</div>